import { Application } from "./../../../../models/application.model";
import { ApplicationService } from "./../../../../services/application/applications.service";
import { CompaniesService } from "./../../../../services/company/companies.service";
import { AuthService } from "./../../../../services/user/auth.service";
import {
  ConfirmationService,
  MessageService,
} from "primeng/components/common/api";
import { TranslateService } from "@ngx-translate/core";
import { User, UserComplex } from "../../../../models/user.model";
import { UsersService } from "../../../../services/user/users.service";
import { Component, OnInit, Input, SimpleChanges } from "@angular/core";
import { KontableComponent } from "app/modules/UIKit/components/kontable/kontable.component";
import { AssociationsService } from "app/services/associations/associations.service";
import { Company } from "app/models/company.model";
import { RoleMSService } from "app/services/utils/roleMS.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { forkJoin } from "rxjs/observable/forkJoin";
import { Observable } from "rxjs";

@Component({
  selector: "app-associations",
  templateUrl: "./associations.component.html",
  styleUrls: ["./associations.component.css"],
})
export class AssociationsComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  companies = [];
  applications = [];
  users = [];
  usersAll = [];
  selectedApp: any;
  selectedCompany: any;
  showAssociationDatesDialog = false;
  showAssociationMsBaseUrlDialog = false;
  showCreationDialog = false;
  selectedAssociation: any;
  editAssociationMode: boolean;
  creationDialogTitle: string;
  selectedUserForRoleChange: {};

  /**
   * Indica il tab di associazione selezionato.
   * Possibili valori:
   *   0: users
   *   1: companies
   *   2: applications
   */
  @Input() activeTab: number;
  /**
   * Indica quale associazione eseguire al salvataggio del form di selezione delle date di inizio e fine
   * Possibili valori: 'user', 'company', 'app'
   */
  associationType: string;
  // Usato come modello per la clonazione degli utenti
  userToClone: { id: number; roleId: number; companies: number[] };
  showRoleChangeDialog: boolean;
  changeUsersRoleForm: FormGroup;

  constructor(
    private associationsService: AssociationsService,
    public srvUsers: UsersService,
    private translateService: TranslateService,
    private confirmationService: ConfirmationService,
    public authService: AuthService,
    private srvCompany: CompaniesService,
    private srvApplication: ApplicationService,
    private messageService: MessageService,
    private rolesService: RoleMSService,
    private formBuilder: FormBuilder
  ) {
    this.changeUsersRoleForm = this.formBuilder.group({
      role: this.formBuilder.group({
        current_role: [null, Validators.required],
      }),
    });
  }

  ngOnInit() {}

  initChangeRoleForm() {}

  getAllUsers() {
    this.associationsService.getAllUsers("", "").subscribe((res) => {
      this.users = res;
      this.usersAll = res;
    });
  }

  getAllCompanies() {
    this.associationsService
      .getAllCompanies()
      .subscribe((res) => (this.companies = res));
  }

  getAllApps() {
    this.associationsService
      .getAllApplications()
      .subscribe((res) => (this.applications = res));
  }

  openAssociationDatesForm(selectedAssociation: any, associationType: string) {
    if (selectedAssociation.associated) {
      this.showAssociationDatesDialog = true;
      this.selectedAssociation = selectedAssociation;
      this.associationType = associationType;
      if (selectedAssociation.date_start && selectedAssociation.date_end) {
        this.editAssociationMode = true;
      } else {
        this.editAssociationMode = false;
      }
    }
  }

  openAssociationMsBaseUrlForm(selectedAssociation: any) {
    if (selectedAssociation.associated) {
      this.showAssociationMsBaseUrlDialog = true;
      this.selectedAssociation = selectedAssociation;
      if (selectedAssociation.msBaseUrl || selectedAssociation.ms_base_url) {
        this.editAssociationMode = true;
      } else {
        this.editAssociationMode = false;
      }
    }
  }

  openChangeUserRoleDialog(user?: User) {
    this.selectedUserForRoleChange = user;
    this.showRoleChangeDialog = true;
  }

  closeChangeUserRoleDialog() {
    this.showRoleChangeDialog = false;
    this.selectedUserForRoleChange = null;
  }

  handleUpdateRoles(updatedUserRoles) {

    const activeRequests: Observable<any>[] = [];

    for (const key in updatedUserRoles) {
      if (updatedUserRoles.hasOwnProperty(key)) {
        const roleData = updatedUserRoles[key];
        const servicePath = `koncentro-${key}`;

        let request$: Observable<any>;

        if ("id" in roleData && roleData.role_id) {
          request$ = this.rolesService.updateRoleForUser(servicePath, roleData);
        } else if ("id" in roleData && !roleData.role_id) {
          request$ = this.rolesService.removeRoleForUser(
            servicePath,
            roleData.id
          );
        } else {
          request$ = this.rolesService.addRoleForUser(servicePath, {
            user_id: roleData.user_id,
            role_id: roleData.role_id,
          });
        }
        activeRequests.push(request$);
      }
    }

    if (activeRequests.length === 0) {
      console.log("No roles changed, skipping API calls.");
      this.messageService.add({
        severity: "info",
        summary: this.translateService.instant("common.info"),
        detail: this.translateService.instant("No roles were updated"),
      });
      this.closeChangeUserRoleDialog();
      return;
    }

    forkJoin(activeRequests).subscribe({
      next: () => {
        console.log("Roles updated successfully");
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("Roles updated successfully"),
        });
        this.closeChangeUserRoleDialog();
      },
      error: (err) => {
        console.error(err);
        this.messageService.add({
          severity: "error",
          summary: this.translateService.instant("common.error"),
          detail: this.translateService.instant("Error updating roles"),
        });
      },
    });
  }

  closeAssociationDatesForm(dates: { startDate: string; endDate: string }) {
    if (this.associationType === "company") {
      if (this.activeTab === 0) {
        this.editAssociationMode
          ? this.editUserCompanyAssociation(this.selectedAssociation, dates)
          : this.createUserCompanyAssociation(this.selectedAssociation, dates);
      }
    } else if (this.associationType === "app") {
      if (this.activeTab === 0) {
        this.editAssociationMode
          ? this.editUserAppCompanyAssociation(this.selectedAssociation, dates)
          : this.createUserAppCompanyAssociation(
              this.selectedAssociation,
              dates
            );
      }
    } else if (this.associationType === "user") {
      if (this.activeTab === 1) {
        this.editAssociationMode
          ? this.editAppUserAssociation(this.selectedAssociation, dates)
          : this.createAppUserAssociation(this.selectedAssociation, dates);
      } else if (this.activeTab === 2) {
        this.editAssociationMode
          ? this.editCompanyUserAssociation(this.selectedAssociation, dates)
          : this.createCompanyUserAssociation(this.selectedAssociation, dates);
      }
    }
    this.showAssociationDatesDialog = false;
  }

  closeMsBaseUrlForm(msBaseUrl: string) {
    if (this.activeTab === 1) {
      this.editAssociationMode
        ? this.editCompanyAppAssociation(this.selectedAssociation, msBaseUrl)
        : this.createCompanyAppAssociation(this.selectedAssociation, msBaseUrl);
    } else if (this.activeTab === 2) {
      this.editAssociationMode
        ? this.editAppCompanyAssociation(this.selectedAssociation, msBaseUrl)
        : this.createAppCompanyAssociation(this.selectedAssociation, msBaseUrl);
    }
    this.showAssociationMsBaseUrlDialog = false;
  }

  closeAssociationDialog() {
    this.showAssociationDatesDialog = false;
    this.showAssociationMsBaseUrlDialog = false;
    if (
      this.selectedAssociation.application_company_id === null ||
      this.selectedAssociation.date_start === null ||
      this.selectedAssociation.msBaseUrl === null ||
      this.selectedAssociation.ms_base_url === null
    ) {
      this.selectedAssociation.associated = false;
    }
  }

  closeCreationDialog() {
    this.userToClone = null;
    this.showCreationDialog = false;
  }

  associateCompany(company) {
    if (this.activeTab === 0) {
      company.associated
        ? this.openAssociationDatesForm(company, "company")
        : this.deleteUserCompanyAssociation(company);
    } else if (this.activeTab === 2) {
      company.associated
        ? this.openAssociationMsBaseUrlForm(company)
        : this.deleteAppCompanyAssociation(company);
    }
  }

  associateApp(appCompany) {
    if (this.activeTab === 0) {
      appCompany.associated
        ? this.openAssociationDatesForm(appCompany, "app")
        : this.deleteUserAppCompanyAssociation(appCompany);
    } else if (this.activeTab === 1) {
      appCompany.associated
        ? this.openAssociationMsBaseUrlForm(appCompany)
        : this.deleteCompanyAppAssociation(appCompany);
    }
  }

  associateUser(user) {
    if (this.activeTab === 0) {
      user.associated
        ? this.openUserAssociationsColumn(user)
        : this.closeUserAssociationsColumn(user);
    } else if (this.activeTab === 1) {
      user.associated
        ? this.openAssociationDatesForm(user, "user")
        : this.deleteAppUserAssociation(user);
    } else if (this.activeTab === 2) {
      // user.associated ? this.createCompanyUserAssociation(user) : this.deleteCompanyUserAssociation(user);
      user.associated
        ? this.openAssociationDatesForm(user, "user")
        : this.deleteCompanyUserAssociation(user);
    }
  }

  /**
   * Crea Associazione Company ad Utente
   */
  createUserCompanyAssociation(
    company: any,
    dates: { startDate: string; endDate: string }
  ) {
    const companyData = {
      company_id: company.company_id,
      date_start: dates.startDate,
      date_end: dates.endDate,
    };
    this.associationsService
      .createUserCompanyAssociation(companyData)
      .subscribe(() => {
        this.refreshUserCompaniesAndApps(company);
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.associateSuccess"),
        });
      });
  }

  /**
   * Modifica Associazione Company ad Utente
   */
  editUserCompanyAssociation(
    company: any,
    dates: { startDate: string; endDate: string }
  ) {
    const companyData = {
      id: company.id,
      company_id: company.company_id,
      date_start: dates.startDate,
      date_end: dates.endDate,
    };
    this.associationsService
      .editUserCompanyAssociation(companyData)
      .subscribe(() => {
        this.refreshUserCompaniesAndApps(company);
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.editAssociation"),
        });
      });
  }

  refreshUserCompaniesAndApps(company: any) {
    const selectedUser = this.users.find(
      (user) => user.id === this.associationsService.rowId
    );
    this.openUserAssociationsColumn(selectedUser, company);
  }

  /**
   * Associa Company ad Application
   */
  createAppCompanyAssociation(company: any, msBaseUrl: string) {
    this.associationsService
      .createAppCompanyAssociation(company.company_id, msBaseUrl)
      .subscribe(() =>
        this.openAppAssociationsColumn(this.selectedApp, company)
      );
  }

  /**
   * Modifica associazione Company ad Application
   */
  editAppCompanyAssociation(company: any, msBaseUrl: string) {
    this.associationsService
      .editAppCompanyAssociation(company, msBaseUrl)
      .subscribe(() =>
        this.openAppAssociationsColumn(this.selectedApp, company)
      );
  }

  /**
   * Crea Associazione di App a Company Utente
   */
  createUserAppCompanyAssociation(
    appCompany: any,
    dates: { startDate: string; endDate: string }
  ) {
    const dataUserAppCompany = {
      company_id: appCompany.company_id,
      application_id: appCompany.application_id,
      date_start: dates.startDate,
      date_end: dates.endDate,
    };
    this.associationsService
      .createUserAppCompanyAssociation(dataUserAppCompany)
      .subscribe(() => {
        this.openCompanyAssociationsColumn(this.selectedCompany);
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.associateSuccess"),
        });
      });
  }

  /**
   * Modifica Associazione di App a Company Utente
   */
  editUserAppCompanyAssociation(
    appCompany: any,
    dates: { startDate: string; endDate: string }
  ) {
    const dataUserAppCompany = {
      company_id: appCompany.company_id,
      application_id: appCompany.application_id,
      date_start: dates.startDate,
      date_end: dates.endDate,
    };
    this.associationsService
      .editUserAppCompanyAssociation(dataUserAppCompany, appCompany.id)
      .subscribe(() => {
        this.openCompanyAssociationsColumn(this.selectedCompany);
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.editAssociation"),
        });
      });
  }

  /**
   * Associa App a Company
   */
  createCompanyAppAssociation(app: any, msBaseUrl: string) {
    const appData = {
      applicationId: app.applicationId,
      msBaseUrl,
    };
    this.associationsService
      .createCompanyAppAssociation(appData)
      .subscribe(() =>
        this.openCompanyAssociationsColumn(this.selectedCompany, app)
      );
  }

  /**
   * Modifica associazione App a Company
   */
  editCompanyAppAssociation(app: any, msBaseUrl: string) {
    const appData = {
      applicationId: app.applicationId,
      msBaseUrl,
    };
    this.associationsService
      .editCompanyAppAssociation(appData, app.id)
      .subscribe(() =>
        this.openCompanyAssociationsColumn(this.selectedCompany, app)
      );
  }

  /**
   * Associa Utente ad App della Company
   */
  createAppUserAssociation(
    user: any,
    dates: { startDate: string; endDate: string }
  ) {
    const userData = {
      user_id: user.user_id,
      application_id: this.selectedApp.applicationId,
      date_start: dates.startDate,
      date_end: dates.endDate,
    };
    this.associationsService
      .createAppUserAssociation(userData)
      .subscribe(() => {
        this.openAppAssociationsColumn(this.selectedApp);
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.associateSuccess"),
        });
      });
  }

  /**
   * Modifica associazione Utente ad App della Company
   */
  editAppUserAssociation(
    user: any,
    dates: { startDate: string; endDate: string }
  ) {
    const userData = {
      user_id: user.user_id,
      application_id: this.selectedApp.applicationId,
      date_start: dates.startDate,
      date_end: dates.endDate,
    };
    this.associationsService
      .editAppUserAssociation(userData, user.id)
      .subscribe(() => {
        this.openAppAssociationsColumn(this.selectedApp);
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.editAssociation"),
        });
      });
  }

  /**
   * Associa Utente a Company dell'App
   */
  createCompanyUserAssociation(
    user: any,
    dates: { startDate: string; endDate: string }
  ) {
    const userData = {
      user_id: user.user_id,
      company_id: this.selectedCompany.company_id,
      date_start: dates.startDate,
      date_end: dates.endDate,
    };
    this.associationsService
      .createCompanyUserAssociation(userData)
      .subscribe(() => {
        this.openCompanyAssociationsColumn(this.selectedCompany);
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.associateSuccess"),
        });
      });
  }

  /**
   * Modifica associazione Utente a Company dell'App
   */
  editCompanyUserAssociation(
    user: any,
    dates: { startDate: string; endDate: string }
  ) {
    const userData = {
      user_id: user.user_id,
      company_id: this.selectedCompany.company_id,
      date_start: dates.startDate,
      date_end: dates.endDate,
    };
    this.associationsService
      .editCompanyUserAssociation(userData, user.id)
      .subscribe(() => {
        this.openCompanyAssociationsColumn(this.selectedCompany);
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.editAssociation"),
        });
      });
  }

  /**
   * Elimina associazione di Company ad Utente
   */
  deleteUserCompanyAssociation(company) {
    this.associationsService
      .deleteUserCompanyAssociation(company.company_id)
      .subscribe(() => {
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.deleteAssociation"),
        });
        company.selected = false;
        company.date_start = null;
        company.date_end = null;
        console.log(company);
      });
  }

  /**
   * Elimina associazione di Company da App
   */
  deleteAppCompanyAssociation(company) {
    this.associationsService
      .deleteAppCompanyAssociation(company.company_id)
      .subscribe(() => {
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.deleteAssociation"),
        });
        company.selected = false;
        company.ms_base_url = null;
        this.users = [];
      });
  }

  /**
   * Elimina associazione App a Company Utente
   */
  deleteUserAppCompanyAssociation(appCompany) {
    this.associationsService
      .deleteUserAppCompanyAssociation(appCompany.applicationCompanyId)
      .subscribe(() => {
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.deleteAssociation"),
        });
        appCompany.date_start = null;
        appCompany.date_end = null;
      });
  }

  /**
   * Elimina associazione di App a Company
   */
  deleteCompanyAppAssociation(app) {
    this.associationsService
      .deleteCompanyAppAssociation(app.companyId, app.applicationId)
      .subscribe(() => {
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.deleteAssociation"),
        });
        app.selected = false;
        app.msBaseUrl = null;
        this.users = [];
      });
  }

  /**
   * Elimina associazione di Utente ad App della Company
   */
  deleteAppUserAssociation(user) {
    this.associationsService
      .deleteAppUserAssociation(user.user_id, this.selectedApp.id)
      .subscribe(() => {
        this.openAppAssociationsColumn(this.selectedApp, this.selectedCompany);
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.deleteAssociation"),
        });
      });
  }

  /**
   * Elimina associazione di User da Company
   */
  deleteCompanyUserAssociation(user) {
    this.associationsService
      .deleteCompanyUserAssociation(user.user_id, user.application_company_id)
      .subscribe(() => {
        this.openCompanyAssociationsColumn(this.selectedCompany);
        this.messageService.add({
          severity: "success",
          summary: this.translateService.instant("common.success"),
          detail: this.translateService.instant("common.deleteAssociation"),
        });
      });
  }

  /**
   * Recupera le Company associabili ad un Utente e le mostra nella relativa colonna
   */
  openUserAssociationsColumn(user, company?) {
    this.users.forEach((user) => (user.selected = false));
    user.selected = true;
    if (this.activeTab === 0) {
      this.applications = [];
      this.associationsService.rowId = user.id;
      this.associationsService
        .getUserCompanyAssociation(user.id)
        .subscribe((res) => {
          this.companies = res;
          if (company) {
            const selectedCompany = this.companies.find(
              (cmp) => cmp.company_id === company.company_id
            );
            this.openCompanyAssociationsColumn(selectedCompany);
          }
        });
    }
  }

  closeUserAssociationsColumn(user) {
    user.selected = false;
    if (this.activeTab === 0) {
      this.companies = [];
    }
  }

  /**
   * Recupera le App associabili ad una Company e le mostra nella relativa colonna
   */
  openCompanyAssociationsColumn(company: any, app?: any) {
    this.selectedCompany = company;
    this.companies.forEach((company) => (company.selected = false));
    company.selected = true;
    if (this.activeTab === 0) {
      this.associationsService
        .getUserAppCompanyAssociation(company.company_id)
        .subscribe((res) => (this.applications = res));
    } else if (this.activeTab === 1) {
      this.users = [];
      this.associationsService.rowId = company.id;
      this.associationsService.getCompanyAppAssociation().subscribe((res) => {
        this.applications = res;
        if (app) {
          const selectedApp = this.applications.find(
            (application) => application.applicationId === app.applicationId
          );
          this.openAppAssociationsColumn(selectedApp);
        }
      });
    } else {
      this.associationsService
        .getAppCompanyUsers(company.company_id)
        .subscribe((res) => (this.users = res));
    }
  }

  /**
   * Recupera gli User associabili ad un App e li mostra nella relativa colonna
   */
  openAppAssociationsColumn(app: any, company?: any) {
    this.selectedApp = app;
    this.applications.forEach((app) => (app.selected = false));
    app.selected = true;
    if (this.activeTab === 1) {
      this.associationsService
        .getCompanyAppUserAssociations(app.applicationId)
        .subscribe((res) => (this.users = res));
    } else if (this.activeTab === 2) {
      this.users = [];
      this.associationsService.rowId = app.id;
      this.associationsService.getAppCompanies().subscribe((res) => {
        this.companies = res;
        if (company) {
          const selectedCompany = this.companies.find(
            (cmp) => cmp.company_id === company.company_id
          );
          this.openCompanyAssociationsColumn(selectedCompany);
        }
      });
    }
  }

  userAdded(data: any) {
    if (this.userToClone) {
      this.srvUsers.clone(data, this.userToClone.id).subscribe(() => {
        this.refreshUserData();
        this.closeCreationDialog();
      });
    } else {
      this.srvUsers.post(data).subscribe(() => {
        this.refreshUserData();
        this.closeCreationDialog();
      });
    }
  }

  refreshUserData() {
    this.getAllUsers();
    this.companies = this.applications = [];
  }

  refreshCompanyData() {
    this.getAllCompanies();
    this.users = this.applications = [];
  }

  refreshAppData() {
    this.getAllApps();
    this.companies = this.users = [];
  }

  userUpdated(data: any) {
    this.srvUsers.put(data).subscribe(() => {
      this.refreshUserData();
      this.closeCreationDialog();
    });
  }

  openCreationDialog(data?: any) {
    if (this.activeTab === 0) {
      let uc = new UserComplex();
      uc.user = data ? data : new User();
      this.creationDialogTitle = data
        ? this.translateService.instant("users.edit_title")
        : this.translateService.instant("users.add_title");
      this.srvUsers.userEditing = uc;
    } else if (this.activeTab === 1) {
      this.creationDialogTitle = data
        ? this.translateService.instant("companyList.edit_title")
        : this.translateService.instant("companyList.add_title");
      this.selectedCompany = data || new Company();
    } else {
      this.creationDialogTitle = data
        ? this.translateService.instant("applicationList.add_title")
        : this.translateService.instant("applicationList.edit_title");
      this.selectedApp = data || new Application();
    }
    this.showCreationDialog = true;
  }

  /**
   * Apre la dialog di clonazione utente
   */
  openCloneUserDialog(user) {
    const userCompanies = [];
    this.associationsService
      .getUserCompanyAssociation(user.id)
      .subscribe((res) =>
        res.forEach((company) => {
          if (company.associated) {
            userCompanies.push(company.company_id);
          }
        })
      );
    this.userToClone = {
      id: user.id,
      roleId: user.role_id,
      companies: userCompanies,
    };
    let uc = new UserComplex();
    uc.user = new User();
    this.srvUsers.userEditing = uc;
    this.showCreationDialog = true;
  }

  deleteUser(user: any) {
    this.confirmationService.confirm({
      header: this.translateService.instant("users.deleteConfirmHeader"),
      message: this.translateService.instant("users.deleteConfirmMsg", {
        userName: user.login,
      }),
      accept: () =>
        this.srvUsers.delete(user).subscribe(() => this.getAllUsers()),
      acceptLabel: "Ok",
      rejectLabel: this.translateService.instant("common.cancel"),
    });
  }

  deleteCompany(company: any) {
    this.confirmationService.confirm({
      header: this.translateService.instant("companyList.deleteConfirmHeader"),
      message: this.translateService.instant("companyList.deleteConfirmMsg", {
        companyName: company.name,
      }),
      accept: () =>
        this.srvCompany.delete(company).subscribe(() => this.getAllCompanies()),
      acceptLabel: "Ok",
      rejectLabel: this.translateService.instant("common.cancel"),
    });
  }

  deleteApp(app: any) {
    this.confirmationService.confirm({
      header: this.translateService.instant(
        "applicationList.deleteConfirmHeader"
      ),
      message: this.translateService.instant(
        "applicationList.deleteConfirmMsg",
        { appName: app.name }
      ),
      accept: () =>
        this.srvApplication.delete(app).subscribe(() => this.getAllApps()),
      acceptLabel: "Ok",
      rejectLabel: this.translateService.instant("common.cancel"),
    });
  }

  companyAdded(data): void {
    this.srvCompany.post(data).subscribe(() => {
      this.refreshCompanyData();
      this.closeCreationDialog();
    });
  }

  companyUpdated(data): void {
    this.srvCompany.put(data).subscribe(() => {
      this.refreshCompanyData();
      this.closeCreationDialog();
    });
  }

  applicationAdded(event): void {
    this.srvApplication.post(event).subscribe(() => {
      this.refreshAppData();
      this.closeCreationDialog();
    });
  }

  applicationUpdated(event): void {
    this.srvApplication.put(event).subscribe(() => {
      this.refreshAppData();
      this.closeCreationDialog();
    });
  }

  getFilteredUsers(event) {
    if (event.query) {
      this.associationsService
        .getAllUsers("", event.query)
        .subscribe((res) => (this.users = res));
    } else {
      this.users = this.usersAll;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.activeTab.currentValue === 0) {
      this.refreshUserData();
    } else if (changes.activeTab.currentValue === 1) {
      this.refreshCompanyData();
    } else {
      this.refreshAppData();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/associations-management/associations/associations.component.ts